// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  align-items: center;
  font-family: Lato, sans-serif;
  justify-content: center;
  padding: 66px 80px;
}

.content {
  display: flex;
  width: 517px;
  max-width: 100%;
  flex-direction: column;
}

.logo {
  aspect-ratio: 4.1;
  -o-object-fit: contain;
     object-fit: contain;
  -o-object-position: center;
     object-position: center;
  width: 472px;
  max-width: 100%;
}

.stepsContainer {
  display: flex;
  margin-top: 72px;
  padding-left: 46px;
  flex-direction: column;
}

.stepContainer {
  background-color: rgb(252, 252, 252);
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px 52px 70px 24px;
}

@media (max-width: 991px) {
  .stepContainer {
    max-width: 100%;
    padding: 0 20px;
  }
}
.headerContainer {
  display: flex;
  gap: 12px;
}

.stepNumber {
  font-feature-settings: "liga" off, "clig" off;
  background-color: rgb(51, 177, 122);
  border-radius: 50%;
  align-self: start;
  font-size: 8px;
  color: var(--Shade-White, #fff);
  font-weight: 700;
  white-space: nowrap;
  text-align: center;
  letter-spacing: 0.16px;
  width: 16px;
  height: 16px;
  padding: 0 6px;
}

.stepTitle {
  color: var(--Shade-Black, #000);
  font-feature-settings: "liga" off, "clig" off;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.25px;
}

.stepDescription {
  color: var(--Shade-Black, #000);
  font-feature-settings: "liga" off, "clig" off;
  font-size: 14px;
  font-weight: 300;
  line-height: 2;
  letter-spacing: 0.25px;
  margin: 4px 0 0 28px;
}

.stepImage {
  aspect-ratio: 0.49;
  -o-object-fit: contain;
     object-fit: contain;
  -o-object-position: center;
     object-position: center;
  width: 195px;
  align-self: center;
  margin-top: 33px;
  max-width: 100%;
}

@media (max-width: 991px) {
  .stepDescription {
    margin-left: 10px;
  }
}
@media (max-width: 991px) {
  .container {
    padding: 0 20px;
  }
  .stepsContainer {
    max-width: 100%;
    padding-left: 20px;
    margin-top: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/modules/support/support.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;AACF;;AAEA;EACE,iBAAA;EACA,sBAAA;KAAA,mBAAA;EACA,0BAAA;KAAA,uBAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,oCAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;AACF;;AAEA;EACE;IACE,eAAA;IACA,eAAA;EACF;AACF;AAEA;EACE,aAAA;EACA,SAAA;AAAF;;AAGA;EACE,6CACE;EAEF,mCAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,+BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAFF;;AAKA;EACE,+BAAA;EACA,6CACE;EAEF,eAAA;EACA,gBAAA;EACA,sBAAA;AAJF;;AAOA;EACE,+BAAA;EACA,6CACE;EAEF,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;AANF;;AASA;EACE,kBAAA;EACA,sBAAA;KAAA,mBAAA;EACA,0BAAA;KAAA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AANF;;AASA;EACE;IACE,iBAAA;EANF;AACF;AASA;EACE;IACE,eAAA;EAPF;EAUA;IACE,eAAA;IACA,kBAAA;IACA,gBAAA;EARF;AACF","sourcesContent":[".container {\n  background-color: rgba(255, 255, 255, 1);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  align-items: center;\n  font-family: Lato, sans-serif;\n  justify-content: center;\n  padding: 66px 80px;\n}\n\n.content {\n  display: flex;\n  width: 517px;\n  max-width: 100%;\n  flex-direction: column;\n}\n\n.logo {\n  aspect-ratio: 4.1;\n  object-fit: contain;\n  object-position: center;\n  width: 472px;\n  max-width: 100%;\n}\n\n.stepsContainer {\n  display: flex;\n  margin-top: 72px;\n  padding-left: 46px;\n  flex-direction: column;\n}\n\n.stepContainer {\n  background-color: rgba(252, 252, 252, 1);\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 24px 52px 70px 24px;\n}\n\n@media (max-width: 991px) {\n  .stepContainer {\n    max-width: 100%;\n    padding: 0 20px;\n  }\n}\n\n.headerContainer {\n  display: flex;\n  gap: 12px;\n}\n\n.stepNumber {\n  font-feature-settings:\n    'liga' off,\n    'clig' off;\n  background-color: rgba(51, 177, 122, 1);\n  border-radius: 50%;\n  align-self: start;\n  font-size: 8px;\n  color: var(--Shade-White, #fff);\n  font-weight: 700;\n  white-space: nowrap;\n  text-align: center;\n  letter-spacing: 0.16px;\n  width: 16px;\n  height: 16px;\n  padding: 0 6px;\n}\n\n.stepTitle {\n  color: var(--Shade-Black, #000);\n  font-feature-settings:\n    'liga' off,\n    'clig' off;\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 0.25px;\n}\n\n.stepDescription {\n  color: var(--Shade-Black, #000);\n  font-feature-settings:\n    'liga' off,\n    'clig' off;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 2;\n  letter-spacing: 0.25px;\n  margin: 4px 0 0 28px;\n}\n\n.stepImage {\n  aspect-ratio: 0.49;\n  object-fit: contain;\n  object-position: center;\n  width: 195px;\n  align-self: center;\n  margin-top: 33px;\n  max-width: 100%;\n}\n\n@media (max-width: 991px) {\n  .stepDescription {\n    margin-left: 10px;\n  }\n}\n\n@media (max-width: 991px) {\n  .container {\n    padding: 0 20px;\n  }\n\n  .stepsContainer {\n    max-width: 100%;\n    padding-left: 20px;\n    margin-top: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
